;(function (factory) {

  if (typeof module === "object" && typeof module.exports === "object") {

    module.exports = factory(require("jquery"), window, document);

  } else {

    factory(jQuery, window, document);

  }

} (function ($, window, document, undefined) {

	var $event = $.event,
		$special,
		scrollTimeout;

	$special = $event.special.debouncedscroll = {
		setup: function() {
			$( this ).on( "scroll", $special.handler );
		},
		teardown: function() {
			$( this ).off( "scroll", $special.handler );
		},
		handler: function( event, execAsap ) {
			// Save the context
			var context = this,
				args = arguments,
				dispatch = function() {
					// set correct event type
					event.type = "debouncedscroll";
					$event.dispatch.apply( context, args );
				};

			if ( scrollTimeout ) {
				clearTimeout( scrollTimeout );
			}

			execAsap ?
				dispatch() :
				scrollTimeout = setTimeout( dispatch, $special.threshold );
		},
		threshold: 100
	};

}));
